import { useEffect, useState } from 'react'
import { getUserDataOrganization } from '../services/ClienteDados/getClientData'

/**
 * Flags de VISIBILIDADE (UI) dos modulos do tenant selecionado (Predict Analytics / Mix Inteligente),
 * lidas de /central/usuario/organizacao/{tenantId}/me. Sao apenas de interface: jobs e processamento
 * em background nao dependem delas. Fonte unica e leve para os gates de modulo espalhados pelas telas
 * (detalhe do cliente, detalhe da predicao, envio de pedido, listagem de predicao).
 *
 * Sem sessao ou sem tenant selecionado, mantem tudo desligado (default seguro). Ausencia de resposta
 * tambem mantem desligado — o modulo so aparece quando o backend confirma que esta ativo no tenant.
 */
export const useModulosTenant = () => {
  const [moduloPredictAnalyticsAtivo, setModuloPredictAnalyticsAtivo] =
    useState(false)
  const [moduloMixInteligenteAtivo, setModuloMixInteligenteAtivo] =
    useState(false)
  // Vira true so quando o /me responde com sucesso. Consumidores que dependem do valor NEGADO da flag
  // (ex.: o chamariz "conheca o Mix", que aparece com o Mix DESLIGADO) devem esperar por ele, senao o
  // default false mostraria o anuncio ate a resposta chegar (ou para sempre, se o /me falhar).
  const [carregado, setCarregado] = useState(false)

  useEffect(() => {
    let ativo = true
    const token = localStorage.getItem('token')
    const xtenant = localStorage.getItem('X-TENANT-ID')
    if (token !== null && xtenant !== null) {
      // X-TENANT-ID e guardado com aspas no localStorage (JSON.stringify); slice remove as aspas.
      const tenant = xtenant.slice(1, -1)
      const buscar = async () => {
        const result = await getUserDataOrganization(tenant)
        if (!ativo || 'message' in result) return
        setModuloPredictAnalyticsAtivo(
          Boolean(result.moduloPredictAnalyticsAtivo)
        )
        setModuloMixInteligenteAtivo(Boolean(result.moduloMixInteligenteAtivo))
        setCarregado(true)
      }
      buscar()
    }
    return () => {
      ativo = false
    }
  }, [])

  return { moduloPredictAnalyticsAtivo, moduloMixInteligenteAtivo, carregado }
}
